import statusLabel from 'helpers/dataProcesses/statusLabel'

const statusIdValue = (value) => {
  return statusLabel(Number(value))
}

export default statusIdValue
